"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
const get_class_name_1 = require("../get-class-name");
exports.propTypes = {
    boxSizing: prop_types_1.default.string,
    clear: prop_types_1.default.string,
    clearfix: prop_types_1.default.bool,
    display: prop_types_1.default.string,
    float: prop_types_1.default.string,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number])
};
exports.propAliases = {};
exports.propValidators = {};
const display = {
    className: 'dspl',
    cssName: 'display',
    jsName: 'display',
    safeValue: true,
    isPrefixed: true
};
const float = {
    className: 'flt',
    cssName: 'float',
    jsName: 'float',
    safeValue: true
};
const clear = {
    className: 'clr',
    cssName: 'clear',
    jsName: 'clear',
    safeValue: true
};
const zIndex = {
    className: 'z-idx',
    cssName: 'z-index',
    jsName: 'zIndex',
    safeValue: true,
    defaultUnit: ''
};
const boxSizing = {
    className: 'box-szg',
    cssName: 'box-sizing',
    jsName: 'boxSizing',
    safeValue: true
};
exports.propEnhancers = {
    boxSizing: (value) => get_css_1.default(boxSizing, value),
    clear: (value) => get_css_1.default(clear, value),
    clearfix: () => ({
        className: `${get_class_name_1.getClassNamePrefix()}clearfix`,
        styles: `
.${get_class_name_1.getClassNamePrefix()}clearfix:before, .${get_class_name_1.getClassNamePrefix()}clearfix:after {
  display: table;
  clear: both;
  content: "";
}`
    }),
    display: (value) => get_css_1.default(display, value),
    float: (value) => get_css_1.default(float, value),
    zIndex: (value) => get_css_1.default(zIndex, value)
};
//# sourceMappingURL=layout.js.map